import "./qualifications.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const Qualifications = () => {
return(
  <div className="margins">
    <h1 className="text-3xl text-white" >Skills</h1>
    <Carousel width={500}  className="ml-32 ">
  <div>
      <img width={400} alt="" src="https://i.ibb.co/KKkMj3f/tailwind.png" />
      <p className="legend text-3xl">Tailwind</p>
  </div>
  <div>
      <img width={400} alt="" src="https://i.ibb.co/bBvsC31/react.png " />
      <p className="legend text-3xl">React.js</p>
  </div>
  <div>
      <img width={400} alt="" src="https://i.ibb.co/QKsHKhg/node.png" />
      <p className="legend text-3xl">Node.js</p>
  </div>
  <div>
      <img width={400} alt="" src="https://i.ibb.co/nzNBkWd/mongo.png" />
      <p className="legend text-3xl">MongoDB</p>
  </div>
  <div>
      <img width={400} alt="" src="https://i.ibb.co/3yTk3LM/firebase.png" />
      <p className="legend text-3xl">Firebase</p>
  </div>
  <div>
      <img width={400} alt="" src=" https://i.ibb.co/zr51Y4L/html.png" />
      <p className="legend text-3xl">Firebase</p>
  </div>
  <div>
      <img width={400} alt="" src=" https://i.ibb.co/DYtxcWn/javascript.png" />
      <p className="legend text-3xl">Firebase</p>
  </div>
  <div>
      <img width={400} alt="" src="https://i.ibb.co/rQ3hxYG/css.png" />
      <p className="legend text-3xl">Firebase</p>
  </div>
</Carousel>
  </div>

)
  // return (
  //   // <div className='overflow-x-scroll'>
      
  //   //   <span className="quali-text">My Qualifications</span>
  //   //   <div className="qualifications-container">
  //   //     <div className="qualification">
  //   //       <div className="content html"></div>
  //   //       <h1>html</h1>
  //   //     </div>
  //   //     <div className="qualification">
  //   //       <div className="content css"></div>
  //   //       <h1>css</h1>
  //   //     </div>
  //   //     <div className="qualification">
  //   //       <div className="content javascript"></div>
  //   //       <h1>javascript</h1>
  //   //     </div>
  //   //     <div className="qualification">
  //   //       <div className="content bootstrap"></div>
  //   //       <h1>bootstrap</h1>
  //   //     </div>
  //   //     <div className="qualification">
  //   //       <div className="content react"></div>
  //   //       <h1>react</h1>
  //   //     </div>
  //   //     <div className="qualification">
  //   //       <div className="content c-plus-plus"></div>
  //   //       <h1>c++</h1>
  //   //     </div>
  //   //     <div className="qualification">
  //   //       <div className="content c-sharp"></div>
  //   //       <h1>c#</h1>
  //   //     </div>
  //   //     <div className="qualification">
  //   //       <div className="content kotlin"></div>
  //   //       <h1>kotlin</h1>
  //   //     </div>
  //   //   </div>
  //   // </div>
  // );
};

export default Qualifications;
